<ng-container *ngIf="isStatic; else staticButton">
	<span class="custom-pill switch-on-off {{ stateClass }}">{{ stateLabel | translate }}</span>
</ng-container>
<ng-template #staticButton>
	<ng-container *ngIf="isStaticButton; else isButton">
		<div
			class="btn-toggle"
			[class.is-invalid]="isInvalid"
			[class.is-disabled]="disabled"
			[class.is-label-revert]="formLabelPostion === 'right'"
		>
			<label *ngIf="formLabel" [translate]="formLabel" class="{{ formLabelClass }}" (click)="onChange($event)"> </label>
			<button
				type="button"
				class="custom-pill switch-on-off {{ stateClass + isBackOffice }}"
				[attr.disabled]="disabled ? true : undefined"
			>
				{{ stateLabel | translate }}
			</button>
		</div>
	</ng-container>
</ng-template>
<ng-template #isButton>
	<div class="btn-toggle" [class.is-invalid]="isInvalid" [class.is-disabled]="disabled" [class.is-label-revert]="formLabelPostion === 'right'">
		<label *ngIf="formLabel" [translate]="formLabel" class="{{ formLabelClass }}" (click)="onChange($event)"> </label>
		<button
			type="button"
			class="custom-pill switch-on-off {{ stateClass }}"
			[attr.disabled]="disabled ? true : undefined"
			(click)="onChange($event)"
		>
			{{ stateLabel | translate }}
		</button>
	</div>
</ng-template>
